const childrensSong = [{
    path: '/childrens_song',
    name: 'childrens_song',
    component() {
        return import('@/views/page/childrens_song.vue')
    }
}, {
    path: '/childrens_song_guide_detail',
    name: 'childrens-song-guide-detail',
    component() {
        return import('@/views/page/childrens_song_guide_detail.vue')
    }
}, {
    path: '/childrens_song_landing',
    name: 'childrens-song-landing',
    component() {
        return import('@/views/page/childrens_song_landing.vue')
    }
}]
export default childrensSong
